<template>
  <div style="padding-left:60px;">
    <div class="" style="padding:40px 10px;">
      <h3 style="padding-bottom: 20px;margin-bottom:20px;border-bottom: 1px solid silver">东北抗日义勇军纪念馆</h3>
      <div style="text-align: justify;text-indent: 2em;line-height:28px;">
        <p>{{content.c1}}</p>
        <p>{{content.c2}}</p>
        <p>{{content.c3}}</p>
        <p>{{content.c4}}</p>
        <p>{{content.c5}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutJian",
  data(){
    return{
      content: {
        c1:'东北抗日义勇军纪念馆地处辽宁省本溪市桓仁满族自治县北山公园，是目前唯一经国家批准的集中展示义勇军抗战史实的纪念性场馆。纪念馆于2017年7月开工兴建，2018年9月建成开放，建筑面积2990平方米，展陈面积2300平方米。展馆内分为序厅、主题展厅、国歌厅、东北抗日义勇军将士名录厅及多功能厅。目前，纪念馆已获评全国爱国主义教育示范基地、国家级抗战纪念设施、中国华侨国际文化交流基地、全国关心下一代党史国史教育基地、辽宁省党性教育现场教学点、辽宁省国防教育基地、辽宁省少先队员校外活动实践基地、辽宁省消防救援队伍思想政治教育基地、辽宁省社会科学普及示范基地等荣誉。作为辽宁六地红色文化名片——“新中国国歌素材地”的代表展馆，东北抗日义勇军纪念馆将不断强化爱国主义教育基地在学习党史、新中国史、改革开放史、社会主义发展史中的职责使命，为深入挖掘辽宁丰富红色资源，大力弘扬抗战文化，为传承红色基因、赓续红色血脉作出应有的贡献。',
        c2:'纪念馆外部浅灰色三层坐北朝南的建筑有两重象征意义，一是代表了东北抗日义勇军的三个特点：自发性、广泛性、复杂性；二是代表了义勇军的三个阶段：早期抗战、英勇抗战、坚持抗战。馆内陈列采用图文展板、多媒体演绎、场景复原、大型雕塑等多种表现形式，讲述了“九一八”事变后，东北各阶层民众和爱国官兵奋起抵抗，在中国共产党的帮助及影响下，以血肉之躯与日本侵略者进行殊死斗争，成为中国人民14年抗日战争的起点，拉开了世界反法西斯战争的历史史实和艰难历程。',
        c3:'纪念馆序厅大型雕塑的主题为“民族烽火”，群体雕塑中间的一位代表中共党员，身后还有农民、知识分子、女性、乡绅、原东北军官兵等形象，寓意东北抗日义勇军包含了东北各阶层民众，在中国共产党的领导下顽强斗争，也充分体现了东北抗日义勇军的自发性和广泛性两个特点。两侧的浮雕反映了东北抗日义勇军同仇敌忾、奋起抗战、众志成城的大无畏精神和保家卫国的英雄气概。',
        c4:'东北抗日义勇军纪念馆的展陈共有五个部分，分别是：第一部分，奋起抵抗——“九一八事变”与东北抗日义勇军的兴起；第二部分，浴血奋战——东北抗日义勇军的对敌斗争；第三部分，不屈不挠——东北抗日义勇军坚持抗战；第四部分，时代强音——东北抗日义勇军与《义勇军进行曲》；第五部分，英灵永驻——东北抗日义勇军将士名录厅。馆内共展出416幅历史图片，其中有164幅是首次面世。刀枪炮弹、纸质书刊、金属瓷器、军事装备等九大类别文物共计535件，多方面、多角度展示了东北抗日义勇军在中国共产党的帮助及影响下腥风血雨的艰难抗战历程。',
        c5:'国歌厅位于展陈的第四部分，由三组大型雕塑与开合式LED屏幕组成，LED屏幕播放的影片主要阐述了《义勇军进行曲》的创作背景和素材形成过程。东北抗日义勇军在长城抗战的战斗历程受到了中国共产党党员田汉、聂耳等左翼文化工作者的关注。《义勇军进行曲》创作之前，田汉、聂耳都曾与辽宁各地的抗日义勇军及其军歌、誓词有过接触。辽宁抗日义勇军的斗争和牺牲精神，激发了田汉、聂耳的创作激情和灵感。1935年，以抗日义勇军为原型创作的《义勇军进行曲》在民族危亡关头诞生，随着电影《风云儿女》的上映迅速唱遍了大江南北，在祖国内外广泛传播，产生了深远的影响。《义勇军进行曲》充分体现了中华民族反抗侵略、勇于战斗不畏牺牲的爱国精神，是20世纪三四十年代中国人民争取自由解放的民族战歌，也是世界反法西斯阵营的国际战歌。',
      },
    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>

</style>
